module.exports = __webpack_public_path__ + "static/profile-pic.84d6255f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/profile-pic.png
// module id = 159
// module chunks = 35783957827783 107818501498521